import type { SVGProps } from 'react';

/** Figma `play-button.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const PlayButtonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M71.3618 31.1746C78.4348 35.0209 78.4348 44.9778 71.3618 48.8241L28.6553 72.0478C21.7811 75.7859 13.3333 70.9204 13.3333 63.223L13.3333 16.7757C13.3333 9.07829 21.7811 4.21276 28.6553 7.95093L71.3618 31.1746Z"
      fill="currentColor"
    />
  </svg>
);
